import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-sr",
  "use": "icon-icon-sr-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-icon-sr\">\n  <path fill=\"#377e3f\" d=\"M0 0h512v512H0z\" />\n  <path fill=\"#fff\" d=\"M0 102.4h512v307.2H0z\" />\n  <path fill=\"#b40a2d\" d=\"M0 153.6h512v204.8H0z\" />\n  <path fill=\"#ecc81d\" d=\"m255.9 163.4 60.2 185.2-157.6-114.5h194.8L195.7 348.6z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol